<script setup lang="ts">
interface Props {
  items: string[]
  title?: string | null
  icon?: string
}

withDefaults(defineProps<Props>(), {
  title: null,
  icon: 'ph--dot',
})
</script>

<template>
  <div class="flex flex-col gap-4">
    <TitleComponent
      v-if="title"
      :text="title"
      type="subtitle"
    />
    <div class="flex flex-col gap-1">
      <template
        v-for="(item, i) in items"
        :key="i"
      >
        <div class="class flex items-center gap-2">
          <div class="mt-1">
            <span :class="getIconClass(icon)" />
          </div>
          <div class="text-sm">
            {{ item }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
